import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { canAccessFinancialDetails } from "utils/helper";
import AgencyFinancialDetails from "./agency";
import FreelancerFinancialDetails from "./freelancer";
function FinancialDetailsPage() {
  const user = useSelector((state) => state.user || {});
  const userDetails = useSelector((state) => state.userDetails || {});
  const isAgency = user?.isAgency ?? false;

  if (!canAccessFinancialDetails(userDetails)) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex flex-1 p-[24px] flex-col gap-[30px]">
      {isAgency ? <AgencyFinancialDetails /> : <FreelancerFinancialDetails />}
    </div>
  );
}

export default FinancialDetailsPage;
